/**
 * @title Currency
 * @description Translations for supported currencies
 */

import {useRecoilValue} from "recoil";
import {LocalizationsAtom} from "../providers/localization/LocalizationProvider";
import {Box} from "@mui/material";
import {useCurrencyConvertQuery} from "../Queries";
import {AppDataAtom} from "../providers/access/ApplicationDataProvider";
import {AccessContextData} from "../providers/access/AppContextProvider";

type CurrencyProps = {
   amount?: number | null
   showMainCurrency?: boolean
   sx?: any
}

export const Currency = ({amount, sx, showMainCurrency}: CurrencyProps) => {
   const appData = useRecoilValue(AppDataAtom);
   const appContext = useRecoilValue(AccessContextData);

   const shopCurrency = appData.shopCurrency;
   const consumerCurrency = appContext.currency!

   if (shopCurrency !== consumerCurrency) {
      return <CalculateCurrency showMainCurrency={showMainCurrency} amount={amount} amountCurrency={shopCurrency} sx={sx}/>
   } else {
      return <PresentCurrency currency={consumerCurrency} amount={amount} sx={sx}/>
   }
}


type CurrencyInnerProps = {
   amount?: number | null
   amountCurrency: string
   sx?: any
   showMainCurrency?: boolean
}

const CalculateCurrency = ({amount, amountCurrency, showMainCurrency, sx}: CurrencyInnerProps) => {
   const appContext = useRecoilValue(AccessContextData);
   const {data} = useCurrencyConvertQuery({
      variables: {
         inputCurrency: amountCurrency || 'DKK',
         inputValue: amount || 0,
         consumerId: appContext.consumerId!,
      }
   })

   return <PresentCurrency currency={data?.ConvertCurrencyForConsumer?.currency || '-'}
                           amount={data?.ConvertCurrencyForConsumer?.value}
                           mainCurrency={showMainCurrency ? amountCurrency : undefined}
                           mainAmount={showMainCurrency ? amount : undefined}
                           sx={sx}/>
}

type PresentCurrencyProps = {
   amount?: number | null
   currency: string

   mainAmount?: number | null
   mainCurrency?: string

   sx?: any
}
export const PresentCurrency = ({amount, currency, mainAmount, mainCurrency, sx}: PresentCurrencyProps) => {
   // Do not remove these lines, used by the prepare script
   //localizations.currency_dkk
   //localizations.currency_eur
   //localizations.currency_sek
   //localizations.currency_nok
   //localizations.currency_pln
   //localizations.currency_gbp
   //localizations.currency_usd
   //localizations.currency_point

   const localizations = useRecoilValue(LocalizationsAtom);
   const innerSx = {
      display: 'inline-block',
      ...sx
   };
   return <Box component={"span"} sx={innerSx}>
      {amount ? Math.round(amount) : '-'} {localizations.getString('currency_' + currency.toLowerCase(), currency)}
      {(currency === "POINT" && mainAmount && mainCurrency !== currency) &&
         <Box component={"span"} sx={{color: 'text.secondary', ml: 1}}>
            ({mainAmount} {mainCurrency})
         </Box>
      }
   </Box>
}